import {
  ButtonComponentConfig,
  ButtonType,
  ButtonSize,
  IconType,
  ActionBehavior
} from '@rappider/rappider-components/utils';

/**
 * Add module action button configuration
 *
 * Configuration for the button that opens the module selection modal.
 */
export const addModuleActionButton: ButtonComponentConfig = {
  key: 'add-module',
  text: 'Add Module',
  icon: {
    name: 'fas fa-plus',
    type: IconType.FontAwesome
  },
  type: ButtonType.Default,
  behavior: ActionBehavior.Emit
};

/**
 * Close button icon configuration for modal
 *
 * Configuration for the close button in the module selection modal.
 */
export const modalCloseButtonIcon = {
  type: IconType.FontAwesome,
  name: 'fa-solid fa-xmark',
  size: ButtonSize.ExtraSmall,
  customColorSettings: {
    backgroundColor: 'var(--component-header-background-color)',
    color: '#ffffff'
  },
  borderSettings: {
    borderColor: 'var(--component-header-background-color)'
  },
  redirectTarget: 'page',
  redirectUrl: 'projects/list'
};
